/* eslint-disable no-unused-vars */
import { Box, Button, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Select from "react-select";
import LoadingSpinner from "../../LoadingSpinner";
import apiClient from "../../utils/ApiClient/apiClientAxios";
import { toastService } from "../../utils/ApiClient/toastService";

const AsignCase = ({ fetchEdssCase, onClose }) => {
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingFetchUser, setLoadingFetchUser] = useState(false);
  const { id, personID } = useParams();

  // Fetch users on mount
  useEffect(() => {
    const fetchUsers = async () => {
      setLoadingFetchUser(true);
      try {
        const response = await apiClient.get("/listUsers");
        const data = response.data;

        if (Array.isArray(data)) {
          const formattedOptions = data.map((email) => ({
            value: email,
            label: email,
          }));
          setOptions(formattedOptions);
        } else {
          console.error("Unexpected response format:", data);
        }
      } catch (err) {
        console.error("Error fetching users:", err);
      } finally {
        setLoadingFetchUser(false);
      }
    };

    fetchUsers();
  }, []);

  const handleSubmit = async () => {
    if (!selectedOption) {
      return toastService.warning("Please select a user");
    }
    setLoading(true);
    const payload = {
      id,
      PERSON_ID: personID,
      ADMINISTRATIVE: {
        ASSIGNED_USER: selectedOption.value,
      },
    };

    try {
      const response = await apiClient.post("/saveEDSSCase", payload);
      const responseData = response.data;

      if (response.status === 200) {
        toastService.success(responseData);
        fetchEdssCase(id, personID);
        setSelectedOption(null);
        onClose();
      } else {
        toastService.error(responseData);
        console.error("Error response:", responseData);
        setSelectedOption(null);
      }
    } catch (err) {
      console.error("API error:", err);
    } finally {
      setLoading(false);
    }
  };
  if (loadingFetchUser) {
    return <LoadingSpinner />;
  }

  return (
    <Box mt={1}>
      <Box minH="50vh">
        <Text fontSize="sm" fontWeight={500}>
          Select user to assign
        </Text>
        <Select
          options={options}
          //   options={formattedOptions}
          value={selectedOption}
          onChange={setSelectedOption}
          placeholder="Select a user..."
          isSearchable
        />
      </Box>
      <Box>
        <Button
          variant="primary"
          onClick={handleSubmit}
          isLoading={loading}
          loadingText="Saving"
        >
          Submit
        </Button>
      </Box>
    </Box>
  );
};

export default AsignCase;
